var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_750_1027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.30852 25.4325C19.872 25.4325 25.6513 16.6786 25.6513 9.08967C25.6513 8.84357 25.6459 8.59201 25.6349 8.34592C26.7592 7.53287 27.7294 6.52579 28.5 5.37201C27.4529 5.83786 26.3412 6.14211 25.2029 6.27435C26.4015 5.55589 27.299 4.42721 27.7289 3.09756C26.6013 3.76581 25.3682 4.23721 24.0823 4.49154C23.216 3.57098 22.0705 2.96146 20.823 2.75722C19.5754 2.55298 18.2954 2.76539 17.1807 3.36161C16.066 3.95783 15.1788 4.90465 14.6562 6.05569C14.1335 7.20673 14.0047 8.49788 14.2895 9.72951C12.0062 9.61493 9.77259 9.02182 7.73331 7.98861C5.69403 6.9554 3.89464 5.50517 2.4518 3.73193C1.71847 4.99628 1.49407 6.49241 1.8242 7.91627C2.15434 9.34012 3.01424 10.5849 4.22914 11.3975C3.31707 11.3685 2.42497 11.123 1.62656 10.6811V10.7522C1.62575 12.079 2.08445 13.3652 2.92469 14.3921C3.76494 15.4189 4.93488 16.1231 6.23562 16.385C5.39073 16.6161 4.50398 16.6498 3.64398 16.4834C4.01103 17.6245 4.72517 18.6225 5.68673 19.3382C6.6483 20.0539 7.80931 20.4515 9.00773 20.4756C6.97316 22.0738 4.45987 22.9406 1.87266 22.9365C1.41383 22.9358 0.955466 22.9077 0.5 22.8523C3.12833 24.5385 6.18579 25.4341 9.30852 25.4325Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_750_1027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.5 0.0566406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterNegative);
export default __webpack_public_path__ + "static/media/twitter-negative.bc2c19c8b60d900b3ed4057ac09f37db.svg";
export { ForwardRef as ReactComponent };